/* TPUSA-MOBILE-MENU (2026-10-18). See assets/tpusa-mobile-menu.css for the matching styles. */
import Cart from 'cart-store';

const MOBILE = window.matchMedia('(max-width: 61.24em)');

/* 1) Cart count + cart button inside the menu drawer ----------------------- */
function initDrawerCart() {
  const counts = document.querySelectorAll('[data-tpm-cart-count]');
  if (counts.length) {
    Cart.subscribe((state) => {
      const n = state && state.cart ? state.cart.item_count : 0;
      counts.forEach((el) => { el.hidden = !n; });
    });
  }
  document.addEventListener('click', async (e) => {
    const link = e.target.closest('[data-tpm-open-cart]');
    if (!link) return;
    const cart = document.getElementById('modal-cart');
    const menu = document.getElementById('modal-main-menu');
    if (!cart || typeof cart.open !== 'function') return; /* no cart drawer (e.g. /cart): follow the link */
    e.preventDefault();
    if (menu && typeof menu.close === 'function' && menu.shown) {
      try { await menu.close(); } catch (err) { /* ignore */ }
    }
    cart.open();
  });
}

/* 4) Transparent-over-hero header: solid once scrolled past the hero (mobile) */
function initHeroHeader() {
  const header = document.querySelector('.js-header');
  if (!header || header.dataset.transparentHeader !== 'true') return;
  const hero = document.querySelector('#main > .shopify-section:first-child');
  if (!hero) return;
  const body = document.body;
  let want = null;

  const compute = () => {
    if (!MOBILE.matches) { want = null; body.classList.remove('tpm-over-hero'); return; }
    const heroBottom = hero.getBoundingClientRect().bottom;
    const headerBottom = header.getBoundingClientRect().bottom;
    want = heroBottom <= headerBottom + 1;
    /* scrolled, but still over the hero: navy scrim keeps the white logo/icons readable */
    body.classList.toggle('tpm-over-hero', !want && window.scrollY > 4);
    if (body.classList.contains('header-stuck') !== want) body.classList.toggle('header-stuck', want);
  };
  /* header-container.js toggles header-stuck from an IntersectionObserver; on mobile we decide */
  new MutationObserver(() => {
    if (want === null) return;
    if (body.classList.contains('header-stuck') !== want) body.classList.toggle('header-stuck', want);
  }).observe(body, { attributes: true, attributeFilter: ['class'] });

  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => { ticking = false; compute(); });
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  if (MOBILE.addEventListener) MOBILE.addEventListener('change', onScroll);
  compute();
}

initDrawerCart();
initHeroHeader();
